import { combineReducers } from '@reduxjs/toolkit';
import filters from './filters/root';
import table from './table/root';

const root = combineReducers({ filters, table });

export default root;
